import React, { Component } from 'react';
import './Images.css';
import en from '../../../../language/en/Images.json';
import es from '../../../../language/es/Images.json';
import Lightbox from './Lightbox/Lightbox';
import { Container } from '@material-ui/core';
import config from '../../../../config/config.json';

class Images extends Component {
	constructor() {
		super();
		this.state = {
			activeFilter: '*',
			allFilterActived: ' cbp-filter-item-active',
			superficieFilterActived: '',
			sateliteFilterActived: '',
			radarFilterActived: '',
			modelosFilterActived: '',
			showSuperficie: true,
			showSatelite: true,
			showRadar: true,
			showModelos: true,
			superficieImgAnim: ' cbp-item-off2on',
			sateliteImgAnim: ' cbp-item-off2on',
			radarImgAnim: ' cbp-item-off2on',
			modelosImgAnim: ' cbp-item-off2on',
			showLightbox: false,
			images: {
				modelos: [],
				radar: [],
				satelite: [],
				superficie: []
			},
			lightboxImg: [],
			currentId: 0
		};

		window.scrollTo(0,0);
	}

	componentDidMount() {
		const url = `${config.apiBaseUrl}/images`;

		//Obteniendo todos las imagenes de los distintos productos (satelite, radar, superficie, ..., modelos)
		fetch(url)
		.then(
			res => {
				return res.json();
			}
		)
		.then(
			data => {
				// console.log('Images = ', data);
				this.setState({
					images: data
				});
				/* for (const key in data) {
					console.log(key);
				} 
				const { modelos, radar, satelite, superficie } = data;
				console.log(modelos, radar, satelite, superficie); */
				
			}
		)
		.catch(
			err => {
				console.log("error ", err);
			}
		);
	}

	changeActiveFilter(e) {
		this.setState({
			activeFilter: e.target.id
		})
		switch (e.target.id) {
			case '*':
				this.setState({					
					allFilterActived: ' cbp-filter-item-active',
					superficieFilterActived: '',
					sateliteFilterActived: '',
					radarFilterActived: '',
					modelosFilterActived: ''
				});
				this.animateItems('*');
				break;

			case '.superficie':
				this.setState({
					allFilterActived: '',
					superficieFilterActived: ' cbp-filter-item-active',
					sateliteFilterActived: '',
					radarFilterActived: '',
					modelosFilterActived: ''
				});
				this.animateItems('.superficie');
				break;

			case '.satelite':
				this.setState({
					allFilterActived: '',
					superficieFilterActived: '',
					sateliteFilterActived: ' cbp-filter-item-active',
					radarFilterActived: '',
					modelosFilterActived: ''
				});
				this.animateItems('.satelite');
				break;

			case '.radar':
				this.setState({
					allFilterActived: '',
					superficieFilterActived: '',
					sateliteFilterActived: '',
					radarFilterActived: ' cbp-filter-item-active',
					modelosFilterActived: ''
				});
				this.animateItems('.radar');
				break;

			case '.modelos':
				this.setState({
					allFilterActived: '',
					superficieFilterActived: '',
					sateliteFilterActived: '',
					radarFilterActived: '',
					modelosFilterActived: ' cbp-filter-item-active'
				});
				this.animateItems('.modelos');
				break;
			
			default:
				
				break;
		}
	}

	animateItems(activeFilter) {
		switch (activeFilter) {
			case '*':
				this.setState({
					superficieImgAnim: ' cbp-item-off2on',
					sateliteImgAnim: ' cbp-item-off2on',
					radarImgAnim: ' cbp-item-off2on',
					modelosImgAnim: ' cbp-item-off2on'
				});
				setTimeout(this.changeVisibleItems.bind(this, '*'), 300);
				break;

			case '.superficie':
				this.setState({
					superficieImgAnim: ' cbp-item-off2on',
					sateliteImgAnim: ' cbp-item-on2off',
					radarImgAnim: ' cbp-item-on2off',
					modelosImgAnim: ' cbp-item-on2off'
				});
				setTimeout(this.changeVisibleItems.bind(this, '.superficie'), 300);
				break;

			case '.satelite':
				this.setState({
					superficieImgAnim: ' cbp-item-on2off',
					sateliteImgAnim: ' cbp-item-off2on',
					radarImgAnim: ' cbp-item-on2off',
					modelosImgAnim: ' cbp-item-on2off'
				});
				setTimeout(this.changeVisibleItems.bind(this, '.satelite'), 300);
				break;

			case '.radar':
				this.setState({
					superficieImgAnim: ' cbp-item-on2off',
					sateliteImgAnim: ' cbp-item-on2off',
					radarImgAnim: ' cbp-item-off2on',
					modelosImgAnim: ' cbp-item-on2off'
				});
				setTimeout(this.changeVisibleItems.bind(this, '.radar'), 300);
				break;

			case '.modelos':
				this.setState({
					superficieImgAnim: ' cbp-item-on2off',
					sateliteImgAnim: ' cbp-item-on2off',
					radarImgAnim: ' cbp-item-on2off',
					modelosImgAnim: ' cbp-item-off2on'
				});
				setTimeout(this.changeVisibleItems.bind(this, '.modelos'), 300);
				break;
			
			default:
				
				break;
		}
	}

	changeVisibleItems(activeFilter) {
		switch (activeFilter) {
			case '*':
				this.setState({
					showSuperficie: true,
					showSatelite: true,
					showRadar: true,
					showModelos: true
				});
				break;

			case '.superficie':
				this.setState({
					showSuperficie: true,
					showSatelite: false,
					showRadar: false,
					showModelos: false
				});
				break;

			case '.satelite':
				this.setState({
					showSuperficie: false,
					showSatelite: true,
					showRadar: false,
					showModelos: false
				});
				break;

			case '.radar':
				this.setState({
					showSuperficie: false,
					showSatelite: false,
					showRadar: true,
					showModelos: false
				});
				break;

			case '.modelos':
				this.setState({
					showSuperficie: false,
					showSatelite: false,
					showRadar: false,
					showModelos: true
				});
				break;
			
			default:
				
				break;
		}
	}

	activateLightbox(e) {
		e.preventDefault();

		const { modelos, radar, satelite, superficie } = this.state.images;
		let lightboxImg;
		switch (this.state.activeFilter) {
			case '*':				
					lightboxImg = modelos.concat(radar).concat(satelite).concat(superficie);
				break;

			case '.modelos':				
					lightboxImg = modelos;
				break;

			case '.radar':				
					lightboxImg = radar;
				break;

			case '.satelite':				
					lightboxImg = satelite;
				break;
			
			case '.superficie':				
					lightboxImg = superficie;
				break;
		
			default:
				
				break;
		}

		let currentId;
		for(let i in lightboxImg)
			if(lightboxImg[i] === e.target.parentNode.href)
				currentId = parseInt(i);
		
		this.setState({
			lightboxImg,
			currentId,
			showLightbox: true
		});
	}

	closeLightbox() {
		this.setState({
			showLightbox: false
		});
	}

	render() {
		const { modelos, radar, satelite, superficie } = this.state.images;

		const modelosComponent = modelos.map((imgSrc, index) => {
			console.log('imagenes', imgSrc)
			return (
				<div key={ index } className={"cbp-item modelos col-sm-3"+this.state.modelosImgAnim}>
					<div className="cbp-caption">
						<div className="cbp-caption-hover-gradient">
							<img src={ imgSrc } alt="" />
						</div>
						<div className="cbp-caption-activeWrap">
							<div className="cbp-l-caption-alignCenter">
								<div className="cbp-l-caption-body portfolio-icons">
									<a onClick={this.activateLightbox.bind(this)} href={ imgSrc } className="cbp-lightbox" data-title="Title">
										<i className="fa fa-search"></i>
									</a>
									<a href=""><i className="fa fa-file"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		});

		const radarComponent = radar.map((imgSrc, index) => {
			return (
				<div key={ index } className={"cbp-item radar col-sm-3"+this.state.radarImgAnim}>
					<div className="cbp-caption">
						<div className="cbp-caption-hover-gradient">
							<img src={ imgSrc } alt="" />
						</div>
						<div className="cbp-caption-activeWrap">
							<div className="cbp-l-caption-alignCenter">
								<div className="cbp-l-caption-body portfolio-icons">
									<a onClick={this.activateLightbox.bind(this)} href={ imgSrc } className="cbp-lightbox" data-title="Title">
										<i className="fa fa-search"></i>
									</a>
									<a href=""><i className="fa fa-file"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		});

		const sateliteComponent = satelite.map((imgSrc, index) => {
			return (
				<div key={ index } className={"cbp-item satelite col-sm-3"+this.state.sateliteImgAnim}>
					<div className="cbp-caption">
						<div className="cbp-caption-hover-gradient">
							<img src={ imgSrc } alt="" />
						</div>
						<div className="cbp-caption-activeWrap">
							<div className="cbp-l-caption-alignCenter">
								<div className="cbp-l-caption-body portfolio-icons">
									<a onClick={this.activateLightbox.bind(this)} href={ imgSrc } className="cbp-lightbox" data-title="Title">
										<i className="fa fa-search"></i>
									</a>
									<a href=""><i className="fa fa-file"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		});

		const superficieComponent = superficie.map((imgSrc, index) => {
			return (
				<div key={ index } className={"cbp-item superficie col-sm-3"+this.state.superficieImgAnim}>
					<div className="cbp-caption">
						<div className="cbp-caption-hover-gradient">
							<img src={ imgSrc } alt="" />
						</div>
						<div className="cbp-caption-activeWrap">
							<div className="cbp-l-caption-alignCenter">
								<div className="cbp-l-caption-body portfolio-icons">
									<a onClick={this.activateLightbox.bind(this)} href={ imgSrc } className="cbp-lightbox" data-title="Title">
										<i className="fa fa-search"></i>
									</a>
									<a href=""><i className="fa fa-file"></i></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		});

		return (
			<section id="images">
	            <div className="portfolio">
	                <Container>
	                    <div className="heading">
	                        <h2>Imágenes de <strong>Satélite&Radar</strong></h2>
	                    </div>

	                    <div className="cube-portfolio">
	                        <div id="filters-container" className="cbp-l-filters-alignCenter">
	                            <div id="*" className={"cbp-filter-item"+this.state.allFilterActived} onClick={this.changeActiveFilter.bind(this)}> Todas... </div>
	                            <div id=".superficie" className={"cbp-filter-item"+this.state.superficieFilterActived} onClick={this.changeActiveFilter.bind(this)}> Superficie </div>
	                            <div id=".satelite" className={"cbp-filter-item"+this.state.sateliteFilterActived} onClick={this.changeActiveFilter.bind(this)}> Satélite </div>
	                            <div id=".radar" className={"cbp-filter-item"+this.state.radarFilterActived} onClick={this.changeActiveFilter.bind(this)}> Radar </div>
	                            <div id=".modelos" className={"cbp-filter-item"+this.state.modelosFilterActived} onClick={this.changeActiveFilter.bind(this)}> Modelos </div>
	                        </div>
	                        <div className="row">                            
	                            <div className="col-md-12">
	                                
	                                <div id="grid-container" className="cbp-l-grid-agency cbp-caption-zoom">
	                                    {
											this.state.showModelos && modelosComponent
										}
	                                    {
											this.state.showRadar && radarComponent
										}
	                                    {
											this.state.showSatelite && sateliteComponent
										}
	                                    {
											this.state.showSuperficie && superficieComponent
										}
	                                </div>
									
	                            </div>
	                            
	                        </div>
	                    </div>
	                </Container>
	            </div>

	            {
	            	this.state.showLightbox && 
	            	<Lightbox images={this.state.lightboxImg} currentId={this.state.currentId} onClose={ this.closeLightbox.bind(this) } />
	            }
	        </section>
		);
	}
}

export default Images;